export const categories = [
  {
    id: 1,
    name: '影视资源',
    slug: 'video',
    icon: 'ri-movie-2-line',
    description: '最新电影、热播剧集、经典影片等影视资源汇总',
    count: 1286,
  },
  {
    id: 2,
    name: '音乐天地',
    slug: 'music',
    icon: 'ri-music-2-line',
    description: '热门歌曲、经典专辑、音乐推荐等音乐资源合集',
    count: 963,
  },
  {
    id: 3,
    name: '图文精选',
    slug: 'gallery',
    icon: 'ri-image-2-line',
    description: '精美图集、摄影作品、设计素材等视觉资源',
    count: 754,
  },
  {
    id: 4,
    name: '资讯快报',
    slug: 'news',
    icon: 'ri-newspaper-line',
    description: '科技动态、行业资讯、社会热点等时事内容',
    count: 2103,
  },
  {
    id: 5,
    name: '学习资料',
    slug: 'learning',
    icon: 'ri-book-open-line',
    description: '课程资源、电子书籍、学术论文等学习材料',
    count: 542,
  },
  {
    id: 6,
    name: '软件工具',
    slug: 'software',
    icon: 'ri-apps-2-line',
    description: '实用软件、效率工具、开源项目等数字资源',
    count: 421,
  },
];